export const SET_PRODUCT_INFORMATIONS = 'SET_PRODUCT_INFORMATIONS'

export const SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT'

export const SET_OPEN_PRODUCT = 'SET_OPEN_PRODUCT'